import { PageHeaderProps } from 'ui/pageHeader';
import noop from 'utils/noop';
import { Skeleton } from 'ui/skeleton';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import {
  AlignedPageHeader,
  MainContentLayout,
  MainLayoutHeaderWrapper,
  SpacedHeaderText,
} from './Styled';
import { EditPredictiveGoalVariables } from '../types';
import { EditGoalInline } from './upsert/edit/EditGoalInline';

export type PredictiveGoalsHeaderProps = {
  background?: string;
  editableGoal: EditPredictiveGoalVariables;
  goalName: string;
  isLoading?: boolean;
  isReadOnly?: boolean;
  onUpdateGoalName?: (goalName: string) => void;
  pageActions?: PageHeaderProps['pageActions'];
};

const SpacedHeaderSkeleton = styled(Skeleton)`
  margin-bottom: ${spacing.double};
`;

export const PredictiveGoalsHeader = ({
  background = '',
  editableGoal,
  goalName,
  isLoading = false,
  isReadOnly = false,
  onUpdateGoalName = noop,
  pageActions = null,
}: PredictiveGoalsHeaderProps) => {
  let goalNameContent = null;

  if (isLoading) {
    goalNameContent = <SpacedHeaderSkeleton isRound height={34} width={600} />;
  } else {
    goalNameContent = isReadOnly ? (
      <SpacedHeaderText>{`${goalName}`}</SpacedHeaderText>
    ) : (
      <EditGoalInline
        goalName={goalName}
        onUpdateGoalName={onUpdateGoalName}
        goalVariables={editableGoal}
      />
    );
  }

  return (
    <MainLayoutHeaderWrapper data-background-color={background}>
      <MainContentLayout>
        <AlignedPageHeader
          documentTitle={`${goalName} | Predictive Goals`}
          pageActions={pageActions}
          breadcrumb={{ href: '/predictive-audiences', content: 'Predictive goals' }}
        >
          {goalNameContent}
        </AlignedPageHeader>
      </MainContentLayout>
    </MainLayoutHeaderWrapper>
  );
};
